import { getHostBridge, isEmbedded } from "@emkit/adapter-emdash/bridge";
import { useEffect } from "react";
import { DndProvider } from "../dnd/DndProvider.js";
import { useKeyboardShortcuts } from "../hooks/useKeyboardShortcuts.js";
import { useEditor } from "../store.js";
import { AIPromptBox } from "./AIPromptBox.js";
import { AISettings } from "./AISettings.js";
import { Canvas } from "./Canvas.js";
import { EmbedBridge } from "./EmbedBridge.js";
import { Inspector } from "./Inspector.js";
import { PageSettings } from "./PageSettings.js";
import { Palette } from "./Palette.js";
import { TemplateGallery } from "./TemplateGallery.js";
import { Toolbar } from "./Toolbar.js";

export function Shell() {
  const mode = useEditor((s) => s.mode);
  const setPlan = useEditor((s) => s.setPlan);
  useKeyboardShortcuts();

  // Pull the active plan from the host's KV at mount so the palette
  // can show lock badges. Standalone editor stays on the default
  // "free" plan; the bridge silently times out and we keep it as is.
  // Guard against the host returning a malformed reply (anything that
  // isn't one of the known plan strings) so a buggy host can't poison
  // the palette into rendering with `plan: undefined`.
  useEffect(() => {
    if (!isEmbedded()) return;
    let cancelled = false;
    getHostBridge()
      .getPlan()
      .then((plan) => {
        if (cancelled) return;
        if (plan === "free" || plan === "pro" || plan === "agency") {
          setPlan(plan);
        }
      })
      .catch(() => {
        // Host hasn't implemented emkit:ai:plan:get yet — stay on free.
      });
    return () => {
      cancelled = true;
    };
  }, [setPlan]);

  return (
    <>
      <DndProvider>
        <div className="emke-shell">
          <Toolbar />
          {mode === "edit" ? <Palette /> : <div className="emke-palette" />}
          <Canvas />
          {mode === "edit" ? <Inspector /> : <div className="emke-inspector" />}
          {mode === "edit" && <AIPromptBox />}
        </div>
      </DndProvider>
      <TemplateGallery />
      <PageSettings />
      <AISettings />
      <EmbedBridge />
    </>
  );
}
